/* eslint-disable @atlassian/relay/unused-fields */
import { graphql } from 'react-relay';

export const COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY = graphql`
	query gqlCountCompassComponentsQuery($cloudId: String!, $query: CompassSearchComponentQuery) {
		compass {
			searchComponents(cloudId: $cloudId, query: $query) {
				__typename
				... on CompassSearchComponentConnection {
					__typename
					totalCount
				}
				... on QueryError {
					message
					extensions {
						__typename
						statusCode
						errorType
					}
				}
			}
		}
	}
`;
